import React from 'react';

const FilterControls = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  campusFilter,
  setCampusFilter,
  sortType,
  setSortType,
}) => {
  return (
    <div className="search-filter">
      <input
        type="text"
        className="search-input"
        placeholder="🔍 Search by company name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select
        className="filter-select"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value="all">All Status</option>
        <option value="Completed">Completed</option>
        <option value="Pending">Pending</option>
      </select>

      <select
        className="filter-select"
        value={campusFilter}
        onChange={(e) => setCampusFilter(e.target.value)}
      >
        <option value="all">All Campus</option>
        <option value="on-campus">On-Campus</option>
        <option value="off-campus">Off-Campus</option>
      </select>

      <select
        className="filter-select"
        value={sortType}
        onChange={(e) => setSortType(e.target.value)}
      >
        <option value="ctc-high">Sort by CTC (High to Low)</option>
        <option value="ctc-low">Sort by CTC (Low to High)</option>
        <option value="placed">Sort by Students Placed</option>
        <option value="company">Sort by Company Name</option>
      </select>
    </div>
  );
};

export default FilterControls;
